import Breadcrumb from "../../Component/Breadcrumb";

function Withdrawal() {
  return (
    <>
      <Breadcrumb>Students / Withdrawal</Breadcrumb>
      <div className="innersec admission_sec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Withdrawal</h1>
          </div>
          <ol>
            <li>
              Applications for Transfer Certificate must be forwarded by the
              parent/guardian of the Student. Transfer Certificate will be
              issued only after the Student has paid all the dues and arrears
              towards the school.
            </li>
            <li>
              If a Student is leaving the school during the school year, he/she
              will have to pay all the dues and fees for the whole of the year
              for the Transfer Certificate to be issued in his/her favor.
            </li>
          </ol>

          <h3>Examinations and Promotions</h3>
          <ol>
            <li>
              Annual promotions are decided through a system of continuous
              assessment throughout the year. The promotion of a Student will be
              on the aggregate basis.
            </li>
            <li>
              The mark obtained in the annual examinations alone will not
              determine the promotion of the Student. The total marks are
              divided among the Periodical Assessments, half yearly and annual
              examinations.
            </li>
            <li>
              If any Student does not show steady and consistent progress in
              studies, he/she is not liable to be promoted. There will be no
              re-examination or examination out of schedule.
            </li>
            <li>
              No leave other than Medical leave will be sanctioned during the
              examination; medical leave is to be applied for when the leave is
              taken and supported by a medical certificate. A fitness
              certificate also must be produced when the Student attends the
              class next. However, he/she will have to forgo the marks in the
              aggregate.
            </li>
            <li>
              Students detected in giving or obtaining or attempting to give or
              obtain unfair assistance at the examinations will be disqualified.
              Students shall not take any books, notes, papers, etc. into the
              examination hall.
            </li>
            <li>
              All cases of doubt regarding evaluation of answer papers and
              promotion test rests entirely at the discretion of the Principal.
            </li>
            <li>
              A Student who fails for two consecutive years in a class will
              automatically be disqualified for continuance of studies in this
              school.
            </li>
            <li>
              Annual promotion from class IX to X and XI to XII will be strictly
              according to the rules and regulations of the CBSE Board.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}
export default Withdrawal;
